import type { QuickStartTier } from '@/lib/api/setup.types';

/**
 * Store-score weighting — mirrors `buildProgress` in
 * `src/lib/quick-start/resolveChecklist.ts` (totalPercent = required×0.7 +
 * recommended×0.3). Required steps unlock "Go live" at 70 pts; recommended
 * steps add the remaining 30. Optional steps are unscored.
 */
export const QUICK_START_REQUIRED_POINTS = 70;
export const QUICK_START_RECOMMENDED_POINTS = 30;

/** Section header bullet — required & recommended read as green, optional as amber. */
export const tierDotClass = (tier: QuickStartTier) => {
  if (tier === 'optional') return 'bg-chart-4';
  return 'bg-primary';
};
